import { FormLabel, FormControl, FormHelperText, Input as ChakraInput } from "@chakra-ui/react";
import type { InputProps } from "./Input.d";

const Input = ({
  errors,
  name,
  type = "text",
  label,
  placeholder,
  register,
  disabled = false,
  helperText,
}: InputProps) => (
  <FormControl isInvalid={errors[name]} isDisabled={disabled} id={name}>
    {label && (
      <FormLabel htmlFor={name} fontWeight="semibold" mb={2}>
        {label}
      </FormLabel>
    )}
    <ChakraInput name={name} type={type} placeholder={placeholder} ref={register} />
    {helperText && <FormHelperText color="greyscale.500">{helperText}</FormHelperText>}
  </FormControl>
);

export default Input;
